const accueilTrad = {
    fr: {
        texte: "Étudiant en design de jeux à Montréal, passionné par le développement de moteurs jeux et d’applications 3D, avec un portfolio de projets personnels et de Game Jams.",
        games: "Mes jeux",
        code: "Mes projets de code",
        pro: "Mes projets profesionnels",
    },
    en: {
        texte: "Game design student in Montreal, passionate about game engine and 3D application development, with a portfolio of personal projects and game jams.",
        games: "My games",
        code: "Programming",
        pro: "Professionals projetcs",
    },
};

export default accueilTrad;
